import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExtensionRoundedIcon from '@mui/icons-material/ExtensionRounded';
import ScatterPlotIcon from '@mui/icons-material/ScatterPlot';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import { useRouter } from '@/hooks';
import Link from '@mui/material/Link';
import { ZoneAndHistory, ZoneStatus } from '@/__generated__/graphql';
import { MenuButton } from './MenuButton';
import { KanbanCardStyles } from './styles';
import { ComplexityChip } from '@/components/shared/ComplexityChip';
import { AssigneeAvatar } from '@/components/ZonesManagementRevamped/AssigneeAvatar';
import { getAssigneeFromHistory } from '../common';

type Props = {
  zone: ZoneAndHistory;
};

export const KanbanCard = ({ zone }: Props) => {
  const router = useRouter();

  const { inspection } = router.query;

  const getRedirectURL = () => {
    return `/inspection/${inspection}?zone=${zone.name}&zoneid=${zone._id}`;
  };

  const assignee = getAssigneeFromHistory(zone);

  // List of statuses that should hide the assignee avatar component
  const statusesToHideAssigneeAvatarOn = [ZoneStatus.NotStarted, ZoneStatus.ReviewReady];

  return (
    <Paper sx={KanbanCardStyles.container} elevation={3}>
      <Box sx={KanbanCardStyles.header}>
        <Link href={getRedirectURL()}>
          <Typography variant="h6" sx={KanbanCardStyles.zoneName}>
            {zone.name}
          </Typography>
        </Link>

        {/* If zone status is not null */}
        {/* If zone status is in the list of statuses to show the menu button on */}
        {zone?.status && <MenuButton zoneId={zone._id} zoneStatus={zone.status} />}
      </Box>

      {/* If assignee is not null */}
      {/* If zone status is not null */}
      {/* If zone status is not in the list of statuses to hide the assignee avatar on */}
      {assignee && zone?.status && !statusesToHideAssigneeAvatarOn.includes(zone.status) ? (
        <AssigneeAvatar assigneeName={assignee.name} profileImage={assignee.profilePicture} />
      ) : (
        <AssigneeAvatar />
      )}

      <ComplexityChip complexity="Low" />

      <Accordion elevation={0} sx={KanbanCardStyles.accordion}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography>More Details</Typography>
        </AccordionSummary>
        <AccordionDetails sx={KanbanCardStyles.accordionDetails}>
          <Box sx={KanbanCardStyles.accordionSummaryIconBox}>
            <ExtensionRoundedIcon />
            <Typography>{zone?.totalParts ? zone?.totalParts : 0} Parts</Typography>
          </Box>

          <Box sx={KanbanCardStyles.accordionSummaryIconBox}>
            <ScatterPlotIcon />
            <Typography>{zone?.totalSphericals ? zone?.totalSphericals : 0} Sphericals</Typography>
          </Box>

          <Box sx={KanbanCardStyles.accordionSummaryIconBox}>
            <DragIndicatorIcon />
            <Typography>{zone?.totalPoints ? zone?.totalPoints : 0} Points</Typography>
          </Box>
        </AccordionDetails>
      </Accordion>
    </Paper>
  );
};
